import EditModule from './EditModule';

export default EditModule;
